<ng-template [ngIf]="isProdEnv && affiliateData?.show">
  <img
    src="https://www.shareasale.com/sale.cfm?tracking={{ affiliateData.orderId }}&amount={{
      affiliateData.amount
    }}&merchantID=103553&transtype=sale"
    width="1"
    height="1"
  />
  <script src="https://www.dwin1.com/19038.js" type="text/javascript" defer="defer"></script>
</ng-template>

<div class="card card-result">
  <ng-container *ngIf="!isError; else errorLayout">
    <status-success
      *ngIf="isSuccessRes"
      [currIsf]="currIsf"
      [currES]="currES"
      [currBondRequest]="currBondRequest"
      [isDelivery]="isDelivery"
      (goToEdit)="goToSummary()"
    ></status-success>
    <status-warning *ngIf="isWarningRes" [currIsf]="currIsf" [currES]="currES" (goToEdit)="goToSummary()"></status-warning>
  </ng-container>
</div>

<ng-container *ngIf="!(isInsuranceLoading | async) && (!!currIsf || !!currES)">
  <app-marine-insurance-quote-pricing-card
    *ngIf="
      !(isInsuranceAvailable | async) &&
      ![enumPaymentState.SUCCESS, enumPaymentState.DELAYED].includes((currentInsurance | async)?.paymentState)
    "
    [marineInsurance]="currentInsurance | async"
    [pendingBills]="currentInsurancePendingBills | async"
    [parent]="parentEntity"
    (edit)="openMarineInsuranceQuoteForm(true)"
  ></app-marine-insurance-quote-pricing-card>

  <app-marine-insurance-quote-updated-pricing-card
    *ngIf="
      !(isInsuranceAvailable | async) &&
      [enumPaymentState.SUCCESS, enumPaymentState.DELAYED].includes((currentInsurance | async)?.paymentState) &&
      (currentInsurance | async)?.pendingPaymentAction === enumMarineInsurancePendingPaymentAction.ADDITIONAL_PAYMENT &&
      (currentInsurancePendingBills | async)?.items?.length
    "
    [marineInsurance]="currentInsurance | async"
    [pendingBills]="currentInsurancePendingBills | async"
  ></app-marine-insurance-quote-updated-pricing-card>
</ng-container>

<div
  *ngIf="!isError && currIsf && currIsf.shipment?.id"
  class="card card-result mt-3 cursor-pointer"
  [routerLink]="['/entry-summary', 'start']"
  [queryParams]="{ isfReferenceNumber: currIsf.referenceNumber }"
>
  <div class="card-body">
    <div class="card-form-header mb">
      <div class="card-form-title">{{ "LABELS.NEXT_STEP" | translate }}</div>
    </div>
    <div class="d-flex w-100">
      <div class="result-img mt-0 mr-3">
        <img src="assets/icons/vessel.svg" />
      </div>
      <div class="flex-grow-1 d-flex flex-column justify-content-center">
        <div class="result-text font-14 mt-0">
          <span [innerHTML]="'INFO.RESULT.CREATE_ENTRY' | translate"></span>
        </div>
      </div>
    </div>
    <div class="w-100">
      <button
        [routerLink]="['/entry-summary', 'start']"
        [queryParams]="{ isfReferenceNumber: currIsf.referenceNumber }"
        type="button"
        class="btn btn-primary btn-create-entry w-100"
      >
        {{ "BUTTON.CREATE_ENTRY" | translate }}
      </button>
    </div>
  </div>
</div>
<div *ngIf="!isError && currES && !isDelivery" class="card card-result mt-3 cursor-pointer" [routerLink]="deliveryRouterLink">
  <div class="card-body">
    <div class="card-form-header mb">
      <div class="card-form-title">{{ "LABELS.NEXT_STEP" | translate }}</div>
    </div>
    <div class="delivery">
      <div class="result-img">
        <img src="assets/icons/ic_delivery.svg" />
      </div>
      <div class="result-text font-14">
        <span [innerHTML]="'INFO.RESULT.DELIVERY.START' | translate"></span>
        <div *ngIf="deliveryOrders?.length">
          <div>{{ "INFO.RESULT.DELIVERY.CREATED_DO" | translate }}:</div>
          <ul>
            <li *ngFor="let deliveryOrder of deliveryOrders">
              {{ deliveryOrder.referenceNumber }}
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="w-100">
      <button [routerLink]="deliveryRouterLink" type="button" class="btn btn-primary btn-create-entry w-100">
        {{ (deliveryOrders?.length ? "BUTTON.ADD_ADDITIONAL_DELIVERY" : "BUTTON.ADD_DELIVERY_ORDER_NOW") | translate }}
      </button>
    </div>
  </div>
</div>
<div class="card card-result verify-phone" *ngIf="!user.phoneNumberConfirmed || isPhoneUpdated">
  <div class="card-body">
    <form [formGroup]="formGroup" [style.width]="'100%'" class="form-group" autocomplete="off">
      <div class="row mb-2">
        <div class="col-12 font-14">{{ "FORM_HELPER.VERIFY_NUMBER" | translate }}</div>
      </div>

      <input-phone
        [fc]="formGroup.get('phoneNumber')"
        [errors]="errors.phoneNumber"
        [label]="'LABELS.MOBILE_NUMBER'"
        [id]="'phoneNumber'"
        [isShowConfirmed]="user.phoneNumberConfirmed && !isChangedPhoneNumber"
      ></input-phone>

      <button
        type="button"
        *ngIf="!user.phoneNumberConfirmed || isChangedPhoneNumber"
        class="btn btn-primary verify-btn"
        [disabled]="!formGroup.get('phoneNumber').value"
        (click)="openVerifyModal()"
      >
        {{ (isVerificationCodeExpired ? "BUTTON.SEND_ME_CODE" : "BUTTON.VERIFY") | translate }}
      </button>
    </form>
  </div>
</div>
<div class="footer-button">
  <button class="btn btn-outline-primary" (click)="goHome()">{{ "INFO.RESULT.HOME" | translate }}</button>
</div>
<ng-template #errorLayout>
  <status-error
    [currIsf]="currIsf"
    [currES]="currES"
    [isDelivery]="isDelivery"
    [currBondRequest]="currBondRequest"
    [error]="error"
    (goToEdit)="goToSummary()"
  ></status-error>
</ng-template>
<app-verify-phone-number [phone]="user?.phoneNumber" (callback)="successPhoneVerification()"></app-verify-phone-number>
<input inputmode="decimal" [pattern]="integerInputMap.pattern" #hiddeninput [ngStyle]="{ position: 'fixed', bottom: '200vh' }" />
